import gql from 'graphql-tag';

export const ORGANIZATION_BY_ID_QUERY_OPTIMIZED = gql`
  query organizationById($id: ID!) {
    organizationById(id: $id) {
      id
      allowComparison
      employees {
        edges {
          cursor
          node {
            id
          }
        }
      }
    }
  }
`;


